export default __webpack_public_path__ + "static/media/clube-img3.d4fb9d98.jpg";